import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../ui/Button";
import Loader from "../../ui/Loader";
import StyledButton from "../../ui/Button/styled";
import isSendingProfessionSelector from "../../../../state/selectors/ProfessionSelectors/isSendingProfessionSelector";
import resetNewProfessionFieldsAction from "../../../../state/actions/ProfessionActions/resetNewProfessionFieldsAction";
import styled from "styled-components";

const SaveNewProfession: React.FC = () => {
    const isSending = useSelector((state: Store) => isSendingProfessionSelector(state));
    const dispatch = useDispatch();
    const resetNewProfessionFields = useCallback(() => dispatch(resetNewProfessionFieldsAction()), [dispatch]);
    return (
        <Wrapper>
            <SaveButton type="submit" primary shadow uppercase isLoading={isSending}>
                Invia {isSending && <Loader light />}
            </SaveButton>
            <Button
                onClick={() => {
                    resetNewProfessionFields();
                }}
                light
                shadow
                uppercase
            >
                Reset
            </Button>
        </Wrapper>
    );
};

export default SaveNewProfession;

const Wrapper = styled.div`
    text-align: right;
    padding-bottom: 1rem;
    position: sticky;
    top: 4.5rem;
    z-index: 1;
    padding: 1rem 3.475rem;
    @media print {
        display: none;
    }
`;

const SaveButton = styled(StyledButton as any)`
    margin-right: 1rem;
`;
